import { FC } from 'react';
import NewSinister from 'images/new-sinisters-icon.svg';

const NewSinisterIcon: FC = () => {
  return <img src={NewSinister} alt="new-sinisters-icon" />;
};
export default NewSinisterIcon;
